import React, { useContext,useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Page404 from "./Page404";
import Login from "../components/Login/Login";
import Main2 from "./Main2";
import AdminUsers from "../components/Section/pages/AdminUsers";
import RegisteredList from "../components/Section/pages/RegisteredList";
import Statistics from "../components/Section/pages/Statistics";
import User from "../components/Section/pages/User";
import Home from "../components/home/Home";
import StatisticsReport from "../components/Section/pages/St-ReportBar/StatisticsReport";
import SetScholarship from "../components/Section/pages/SetScholarship";
import SetDocument from "../components/Section/pages/SetDocument";
import Logs from "../components/Section/pages/Logs";
import Process from "../components/Section/Contents/FormProcess/Process";
import FormStep from "../components/Section/Contents/FormProcess/ProcessContents/FormStep";
import FormProcessHome from "../components/Section/Contents/FormProcess/FormProcessHome";
import MyApplication from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/MyApplication";
import ApplyScholarship from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/ApplyScholarship";
import UploadDocument from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/UploadDocument";
import StudentSupport from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/StudentSupport";
import UpdateLoginDetail from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/UpdateLoginDetail";
import Invoice from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/Invoice";
import Applicants from "../components/Section/pages/Applicants";
import AccountHelper from "../components/Section/pages/AccountHelper";
import Award from "../components/Section/pages/Award";
import Dispute from "../components/Section/pages/Dispute";
import Verification from "../components/Section/pages/Verification";
import MyAppDetails from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/MyAppDetails";
import Settings from "../components/Section/pages/Settings";
import Audit from "../components/Section/pages/Audit";
import AddDocument from "../components/Section/Contents/Settings/AddDocument";
import UpdatePassword from "../components/Section/Contents/Settings/UpdatePassword";
import Reviewer from "../components/Section/pages/Reviewer";
import { ContextData } from "../context/Context";
import ApplicantPrivateRoute from "./privateRoute/ApplicantPrivateRoute";
import DashboardPrivateRoute from "./privateRoute/DashboardPrivateRoute";
import SelectionProcess from "../components/Section/pages/SelectionProcess";
import LimitApplicants from "../components/Section/Contents/Settings/LimitApplicants";
import AddUniversity from "../components/Section/Contents/Settings/AddUniversity";
import LimitScholarship from "../components/Section/Contents/Settings/LimitScholarship";
import LoanApplication from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/LoanApplication";
import ApplyLoan from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/ApplyLoan";
import MainPreview from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/MainPreview";
import SetLoan from "../components/Section/pages/SetLoan";
import Bankreviewer from "../components/Section/pages/Bankreviewer";
import AddBank from "../components/Section/Contents/Settings/AddBank";
import ApprovalLoan from "../components/Section/pages/ApprovalLoan";
import { Getrequest } from "../context/AxiosRequest";
import UploadDocumentSettings from "../components/Section/Contents/Settings/UploadDocumentSettings";
import LoanSupport from "../components/Section/pages/LoanSupport";
import Offers from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/Offers";
import InPrincipleOfferThirdParty from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/offersAll/InPrincipleOfferThirdParty";
import DisbursementUtilizationForm from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/offersAll/DisbursementUtilizationFormThirdParty";
import InPrincipleOfferStudentLoan from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/offersAll/InPrincipleOfferStudentLoan";
import DisbursementUtilizationFormStudentLoan from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/offersAll/DisbursementUtilizationFormStudentLoan";
import DisbursementUtilizationFormThirdParty from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/offersAll/DisbursementUtilizationFormThirdParty";
import Disbursement from "../components/Section/pages/Disbursement";
import ForgettenPassword from "../components/Section/pages/ForgettenPassowrd";
import FinalOffer from "../components/Section/Contents/FormProcess/ProcessContents/SectionContent/offersAll/FinalOffer";
import Matrix from "../components/Section/pages/Matrix";




function Router() {



  const {accesstoken}  = useContext(ContextData)

    useEffect(() => {
      
         
      (async ()=>{
            
           Getrequest("/pub/visitor",accesstoken)


      })()
       
   

     
   }, []);


  return (
    <Routes>
     
  
      <Route path="/dashboard" element={<DashboardPrivateRoute accessToken={accesstoken}> <Main2 /> </DashboardPrivateRoute>}>

        <Route path="adminusers" element={<AdminUsers />} />
        <Route path="selection" element={<SelectionProcess />} />
        <Route path="applicants" element={<Applicants />} />
        <Route path="account-helper" element={<AccountHelper />} />
        <Route path="reviewer" element={<Reviewer />} />
        <Route path="award" element={<Award />} />
        <Route path="dispute" element={<Dispute />} />
        <Route path="verification" element={<Verification />} />
        <Route path="loan_supports" element={<LoanSupport />} />
        <Route path="bank_reviewer" element={<Bankreviewer />} />
        <Route path="approval_loan" element={<ApprovalLoan />} />
        <Route path="user" element={<User />} />
        <Route path="statistics" element={<Statistics />} />
        <Route path="report_statistics" element={<StatisticsReport />} />
        <Route path="setpayment" element={<SetScholarship />} />
        <Route path="setloan" element={<SetLoan />} />
        <Route path="setdocument" element={<SetDocument />} />
        <Route path="logs" element={<Logs />} />
        <Route path="settings" element={<Settings />}>
         <Route path="matrix" element={<Matrix />} />
        <Route path="matrix" element={<Matrix />} />



          <Route path="update-password" element={<UpdatePassword />} />
          <Route path="add-document" element={<AddDocument />} />
          <Route path="upload-document" element={<UploadDocumentSettings />} />
          <Route path="limitscholarship" element={<LimitScholarship />} />
          <Route path="add-university" element={<AddUniversity />} />
          <Route path="add-bank" element={<AddBank />} />
          

          
        </Route>
        <Route path="audit" element={<Audit />} />
      </Route>   
      
      {/* route for admin users and third party */}
       <Route path="/process" element={<DashboardPrivateRoute accessToken={accesstoken}> <Main2 /> </DashboardPrivateRoute>}>
        
        <Route path="selection" element={<SelectionProcess />} />
        <Route path="applicants" element={<Applicants />} />
        <Route path="account-helper" element={<AccountHelper />} />
        <Route path="reviewer" element={<Reviewer />} />
        <Route path="award" element={<Award />} />
        <Route path="dispute" element={<Dispute />} />
        <Route path="verification" element={<Verification />} />
        <Route path="loan_supports" element={<LoanSupport />} />
     

     {/*   <Route path="bank_reviewer" element={<Verification />} />
        */}
      </Route>


      <Route path="/loan_general" element={<DashboardPrivateRoute accessToken={accesstoken}> <Main2 /> </DashboardPrivateRoute>}>
        
        
        <Route path="applicants" element={<Applicants />} />
        <Route path="dispute" element={<Dispute />} />
        <Route path="verification" element={<Verification />} />
        <Route path="loan_supports" element={<LoanSupport />} />
        <Route path="approval_loan" element={<ApprovalLoan />} />
        <Route path="disbursement" element={<Disbursement />} />
         <Route path="bank_reviewer" element={<Bankreviewer />} />
        <Route path="matrix" element={<Matrix />} />

          <Route path="settings" element={<Settings />}>
          <Route path="update-password" element={<UpdatePassword />} />
          <Route path="add-document" element={<AddDocument />} />
          <Route path="upload-document" element={<UploadDocumentSettings />} />
         
          
          
        </Route>

     {/*   <Route path="bank_reviewer" element={<Verification />} />
        */}
      </Route>


      <Route path="/loan_manage" element={<DashboardPrivateRoute accessToken={accesstoken}> <Main2 /> </DashboardPrivateRoute>}>
        
        
        <Route path="applicants" element={<Applicants />} />
        <Route path="dispute" element={<Dispute />} />
        <Route path="loan_supports" element={<LoanSupport />} />
        <Route path="approval_loan" element={<ApprovalLoan />} />
        <Route path="matrix" element={<Matrix />} />

         
          <Route path="settings" element={<Settings />}>
          <Route path="update-password" element={<UpdatePassword />} />
          
        </Route>

     {/*   <Route path="bank_reviewer" element={<Verification />} />
        */}
      </Route>  
      
        <Route path="/verifier_loan" element={<DashboardPrivateRoute accessToken={accesstoken}> <Main2 /> </DashboardPrivateRoute>}>
        
        
        <Route path="applicants" element={<Applicants />} />
         <Route path="matrix" element={<Matrix />} />
        <Route path="verification" element={<Verification />} />
        <Route path="loan_supports" element={<LoanSupport />} />
       
         
          <Route path="settings" element={<Settings />}>
          <Route path="update-password" element={<UpdatePassword />} />
          
        </Route>

   
      </Route>

 
       <Route path="/banks" element={<DashboardPrivateRoute accessToken={accesstoken}> <Main2 /> </DashboardPrivateRoute>}>

         <Route path="bank_reviewer" element={<Bankreviewer />} />

          <Route path="settings" element={<Settings />}>
          <Route path="update-password" element={<UpdatePassword />} />
          
        </Route>
       
      </Route>

      

      {/* Home Page */}
      <Route path="/home" element={<Home />} />

      <Route path="/application" element={<ApplicantPrivateRoute accessToken={accesstoken}> <Process /> </ApplicantPrivateRoute>}>

        <Route path="form_process" element={<FormStep />}  />
        <Route path="home" element={<FormProcessHome />} />
        <Route path="my_application" element={<MyApplication />} />
        <Route path="loan_application" element={<LoanApplication />} />
        <Route path="my_application_details" element={<MyAppDetails />} />
        <Route path="apply_scholarship" element={<ApplyScholarship />} />
        <Route path="preview_application" element={<MainPreview />} />
        <Route path="upload_document" element={<UploadDocument />} />
        <Route path="student_support" element={<StudentSupport />} />
        <Route path="update_login_detail" element={<UpdateLoginDetail />} />
        <Route path="offers" element={<Offers />}>
        <Route path="inprinciple_offer_thirt_party" element={<InPrincipleOfferThirdParty />} />
        <Route path="inprinciple_offer_student" element={<InPrincipleOfferStudentLoan />} />
        <Route path="utilization_letter_thirt_party/:guarantor/:amountOffered" element={<DisbursementUtilizationFormThirdParty />} />
        <Route path="utilization_letter_student/:guarantor/:amountOffered" element={<DisbursementUtilizationFormStudentLoan />} />
        <Route path="final_offer" element={<FinalOffer />} />
            
        </Route>

        <Route path="invioce" element={<Invoice />} />
        <Route path="apply_loan" element={<ApplyLoan />} />
        
      </Route> 

      {/* Catch route */}
      <Route element={<Navigate to="/home" />} index />
      <Route path="/404" element={<Page404 />} />
      <Route path="*" element={<Navigate to="/404" />}  /> 

      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgettenPassword />} />



    </Routes>
  );
}

export default Router;
